var React = require('react');

function CodepenInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M0.3 12.4L8.6 17.9C8.8 18 9.1 18 9.4 17.9L17.7 12.4C17.9 12.2 18 12 18 11.7V6.3C18 6 17.9 5.8 17.7 5.6L9.4 0.1C9.2 0 8.9 0 8.6 0.1L0.3 5.6C0.1 5.8 0 6 0 6.3V11.7C0 12 0.1 12.2 0.3 12.4ZM8.2 15.8L2.2 11.7 4.9 9.9 8.2 12.2V15.8ZM9.8 15.8V12.2L13.1 9.9 15.8 11.7 9.8 15.8ZM16.5 10.3L14.5 9 16.5 7.7V10.3ZM9.8 2.2L15.8 6.3 13.1 8.1 9.8 5.8V2.2ZM9 7.2L11.7 9 9 10.8 6.3 9 9 7.2ZM8.2 2.2V5.8L4.9 8.1 2.2 6.3 8.2 2.2ZM1.5 7.7V7.7L3.5 9 1.5 10.3V7.7Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",null)))]);
}

CodepenInline.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = CodepenInline;

CodepenInline.default = CodepenInline;
